// import uuid from 'uuid/v4'
// constants
export const AUTH = 'authentication'
export const PROPOSAL = 'proposal'

class localStgHelper {
  /**
   * will look up and store array of objects in localStorage
   * @param {string} key key of item in localStorage
   * @param {object} value value to add to localStorage must be an object
   */
  static add (key, value) {
    const uuid = undefined
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          const current = localStgHelper._fetch(key)
          let updatedContent = null
          let newObject = null
          if (current.length) {
            const existingRecord = await localStgHelper.fetchByParam(key, 'email', value)
            if (existingRecord.value.length) {
              return resolve({ error: 'This email already exists.', status: false, value: [existingRecord.value[0]] })
            }
            const id = uuid()
            newObject = { id, ...value }
            updatedContent = [...current, newObject]
          } else {
            newObject = { id: uuid(), ...value }
            updatedContent = [newObject]
          }
          return resolve({ status: localStgHelper._save(key, updatedContent), value: [newObject] })
        } catch (error) {
          return reject(error)
        }
      }, 1500)
    })
  }

  static update (key, value, param = 'id') {
    return new Promise((resolve, reject) => {
      try {
        const current = localStgHelper._fetch(key)
        // remove updated item from record and push update into array
        let updatedContent = current.filter(item => {
          if (value[param] !== item[param]) {
            return item
          }
        })
        updatedContent.push(value)
        return resolve({ status: localStgHelper._save(key, updatedContent), value: updatedContent })
      } catch (error) {
        return reject(error)
      }
    })
  }

  static updateWhere (key, where, value, param = 'id') {
    return new Promise((resolve, reject) => {
      try {
        const currentStore = localStgHelper._fetch(key)

        const updatedContent = currentStore.map(item => {
          if (item.id === where) {
            return { ...item, ...value }
          }
          return item
        })
            
        return resolve({ status: localStgHelper._save(key, updatedContent), value: updatedContent })
      } catch (error) {
        return reject(error)
      }
    })
  }

  static delete (key, id) {
    return new Promise((resolve, reject) => {
      try {
        const current = localStgHelper._fetch(key)
        if (!current) return false
        const updatedContent = current.filter(item => item.id !== id)
        return resolve({ status: localStgHelper._save(key, updatedContent) })
      } catch (error) {
        return reject(error)
      }
    })
  }

  static deleteWhere (key, user, where) {
    return new Promise((resolve, reject) => {
      try {
        const current = localStgHelper._fetch(key)
        if (!current) return false

        const updatedContent = current.map(item => {
          if (item.id === user.id) {
            delete item[where]
            return item
          }
          return item
        })
        
        return resolve({ status: localStgHelper._save(key, updatedContent) })
      } catch (error) {
        return reject(error)
      }
    })
  }

  static fetchByParam (key, param, objectRecord) {
    return new Promise((resolve, reject) => {
      try {
        const current = localStgHelper._fetch(key)
        if (!current) return resolve({ value: [] })
        return resolve({ status: true, value: current.filter(item => item[param] && item[param] === objectRecord[param]) })
      } catch (error) {
        return reject(error)
      }
    })
  }

  static _fetch (key) {
    return JSON.parse(window.localStorage.getItem(key)) || []
  }

  static _save (key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (err) {
      console.error({ err })
      return false
    }
  }
}

export default localStgHelper
